module.exports = __webpack_public_path__ + "img/h_s2e1_gallery_1.5bee96ec.png";